export default "__VITE_ASSET__D1Ue8gQN__"